export default __webpack_public_path__ + "static/media/placeholderImg.3d09a12d.jpg";